import React, { Component } from 'react';
import styled from 'styled-components';
import { observer, inject } from 'mobx-react';
import html2canvas from 'html2canvas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCaretLeft,
  faCaretRight,
  faRedoAlt
} from '@fortawesome/free-solid-svg-icons';

import { SheetFormat } from '../../types';
import KarteStore from '../../store';
import logo from '../../icon.png';

const downloadImage = (data: string) => {
  const fileName: string = 'screenshot.jpeg';
  const encodedData = atob(data.replace(/^.*,/, ''));
  const outputData = new Uint8Array(encodedData.length);
  for (let i = 0; i < encodedData.length; i++) {
    outputData[i] = encodedData.charCodeAt(i);
  }
  // const blob = new Blob([outputData], { type: 'image/jpeg' });
  // if (window.navigator.msSaveBlob) {
  //   //IE用
  //   window.navigator.msSaveOrOpenBlob(blob, fileName);
  // } else {
  data = data.replace('data:image/jpeg;base64,', '');
  const finalImageSrc = 'data:image/jpeg;base64,' + data;
  const element = document.createElement('a');
  element.href = finalImageSrc;
  element.download = fileName; //ダウンロードファイル名設定
  element.click(); //自動クリック
  // }
};

interface Props {
  karte?: KarteStore;
}

@inject('karte')
@observer
class Header extends Component<Props> {
  render() {
    const karte = this.props.karte;
    if (!karte) return null;
    return (
      <Wrapper>
        <LeftContents>
          <LogoImg src={logo} alt="logo" />

          <div>
            <Title>統計情報表示システム</Title>
            <SheetContainer>
              <SheetSelectButton
                className="sheet-selector-desc"
                onClick={karte.showSheetSelection}
              >
                シートを選ぶ
              </SheetSelectButton>
              {karte.sheetFormat === SheetFormat.Customize && (
                <ResetContainer>
                  <ResetButton
                    icon={faRedoAlt}
                    size="1x"
                    onClick={() => {
                      alert(
                        '全てのカスタマイズシートがリセットされます。よろしいですか？'
                      );
                      karte.resetCustomizeSettings();
                    }}
                  />
                  <ResetButtonDesc className="reset-customize-sheet">
                    カスタマイズシートを全てリセット
                  </ResetButtonDesc>
                </ResetContainer>
              )}
            </SheetContainer>
          </div>
        </LeftContents>
        {karte.sheetFormat === SheetFormat.Template && (
          <CenterContents>
            <ChangeSheetButton onClick={karte.prevTemplateSheetPage.bind(this)}>
              <FontAwesomeIcon icon={faCaretLeft} size="2x" />
            </ChangeSheetButton>
            <SheetNumber>
              {karte.numberOfCurrentTemplatePage + 1}/{karte.template.length}
            </SheetNumber>
            <ChangeSheetButton onClick={karte.nextTemplateSheetPage.bind(this)}>
              <FontAwesomeIcon icon={faCaretRight} size="2x" />
            </ChangeSheetButton>
          </CenterContents>
        )}

        <RightContents>
          <PrintButton onClick={() => window.print()}>印刷</PrintButton>
          <ScreenshotButton
            onClick={() => {
              html2canvas(document.body, {
                allowTaint: false,
                useCORS: false
              }).then(function(canvas) {
                downloadImage(canvas.toDataURL('image/jpeg'));
              });
            }}
          >
            スクリーンショット
          </ScreenshotButton>
        </RightContents>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background: #fff;
  justify-content: space-between;
  border-bottom: solid 1px #ddd;
`;

const LeftContents = styled.div`
  display: flex;
  align-items: center;
`;

const CenterContents = styled.div`
  display: flex;
  align-items: center;
`;

const RightContents = styled.div`
  margin-right: 20px;
`;

const LogoImg = styled.img`
  width: 56px;
  padding: 10px;
`;

const Title = styled.p`
  font-size: 20px;
  color: #555;
  display: inline-block;
  margin: 5px 10px;
  vertical-align: middle;
`;
const SheetContainer = styled.div`
  display: inline-block;
`;

const StyledButton = styled.button`
  cursor: pointer;
  padding: 8px 20px;
  border: none;
  border-radius: 3px;
  margin: 0 5px;
`;

const SheetSelectButton = styled(StyledButton)`
  background: #4a90e2;
  color: #fff;
  margin: 5px 10px;
  display: inline-block;
  vertical-align: middle;
`;

const ResetContainer = styled.div`
  display: inline-block;
  position: relative;
`;

const ResetButton = styled(FontAwesomeIcon)`
  cursor: pointer;
  margin: 0 5px;
  text-align: center;
  &:hover + .reset-customize-sheet {
    display: block;
  }
`;

const ResetButtonDesc = styled.p`
  font-size: 12px;
  padding: 8px 20px;
  border-radius: 3px;
  display: none;
  color: #fff;
  position: absolute;
  top: 30px;
  left: 0px;
  width: 200px;
  z-index: 950;
  background: rgba(0, 0, 0, 0.8);
  &:after {
    position: absolute;
    width: 0;
    height: 0;
    left: 5px;
    top: -20px;
    border: solid transparent;
    border-bottom-color: rgba(0, 0, 0, 0.8);
    border-width: 10px;
    pointer-events: none;
    content: ' ';
  }
`;

const ChangeSheetButton = styled.div`
  color: #4a90e2;
  padding: 5px;
  cursor: pointer;
`;

const SheetNumber = styled.div`
  margin: 0 10px;
`;

const PrintButton = styled(StyledButton)`
  background: #4a90e2;
  color: #fff;
`;

const ScreenshotButton = styled(StyledButton)`
  background: #4a90e2;
  color: #fff;
`;

export default Header;
